
export default {
  data() {
    return {
      value: '',
      isFocussed: false,
      isShowingWarning: false,
    };
  },

  props: {
    type: {
      type: String,
      default: 'text',
    },
    required: {
      type: Boolean,
      default: false,
    },
    defaultValue: String,
    name: String,
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasValue: function () {
      return this.value.length > 0;
    },
    maxTextareaHeight: function () {
      return 1000;
    },
  },

  watch: {},

  methods: {
    onChangeFile: function (e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.value = files[0].name;
    },
    onFocus: function () {
      this.isFocussed = true;
    },
    onBlur: function () {
      this.isFocussed = false;
      this.isShowingWarning = (this.required && !this.value.length);
    },
    didSelectClear: function (e) {
      e.preventDefault();
      this.$emit('input', null);
    },
  },

  components: {},

  created() {},

  destroyed() {},

  mounted() {
    this.value = this.defaultValue;
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/TextInput.vue